module.exports = __webpack_public_path__ + "img/mega-man-min.e4b16034.png";